import {SymbolSizes} from '@gongxigames/framework/slot';

export class PickBonusConstants {
    public static readonly FREE_SPINS_TEXT_ID: string = 'popupIntroTXT_2';
    public static readonly REMOVED_TEXT_ID: string = 'popupIntroTXT_3';
    public static readonly MEDALLION_TEXT_ID: string = 'pickBonusTXT_1';
    public static readonly AUTO_PICK_TEXT_ID: string = 'pickBonusTXT_2';
    public static readonly SHEEN_TIMER: number = 5000;
    public static readonly AUTO_PLAY_DELAY_TIME: number = 500;
    public static readonly FLYING_TIME: number = 750;
    public static readonly FREE_SPINS_OUTRO_START_DELAY: number = 2000;
    public static readonly DIAMOND_SYMBOL_SLOT: SymbolSizes = {
        width: 164,
        height: 130
    };
    public static readonly COIN_PLACEMENT_Y_OFFSET: number = 217;
}
